<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Operators'"
        :buttons="[
          {
            title: 'Reload',
            icon: 'fas fa-sync',
            emit: 'get',
          },
        ]"
        @get="get()"
      ></cardHead>

      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-10"
        ref="form"
      >
        <formGroup
          :title="'CountryId'"
          :as="'select'"
          :disabled="countries.length == 0"
          v-model="countryId"
          :errors="errors"
          @change="get"
        >
          <template #input>
            <option v-for="item in countries" :value="item.Id" :key="item.Id">{{
              item.Name
            }}</option>
          </template>
        </formGroup>
      </Form>
      <dataTable
        :name="'OperatorList'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="data"
        @cellClicked="detailShow = $event.data"
        @create="createOpen = $event.Id"
        @updateExchange="updateExchangeShow = $event.Id"
      ></dataTable>
    </div>
  </div>
  <detail
    v-if="detailShow != null"
    :operators="data"
    :operator="detailShow"
    @update="$refs.agGrid.changeRow('Id', $event)"
    @close="detailShow = null"
    @get="get"
  ></detail>
  <create
    v-if="createOpen != null"
    @close="createOpen = null"
    :id="createOpen"
    @get="get()"
  ></create>
  <updateExchange
    v-if="updateExchangeShow != null"
    :id="updateExchangeShow"
    @close="updateExchangeShow = null"
  ></updateExchange>
</template>

<script>
import detail from "./detail";
import create from "./cookies/create";
import updateExchange from "./updateExchange";
export default {
  name: "Operators",
  components: { detail, create, updateExchange },
  data() {
    return {
      data: null,
      countries: [],
      countryId: 228,
      columnDefs: [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "MainOperatorId",
          field: "MainOperatorId",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 160,
        },
        {
          headerName: "CurrencyCode",
          field: "CurrencyCode",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "OutputPort",
          field: "OutputPort",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "MaxHotelCount",
          field: "MaxHotelCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "MaxDayCount",
          field: "MaxDayCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "OutputCount",
          field: "OutputCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "DepartureCityCount",
          field: "DepartureCityCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 180,
        },
        {
          headerName: "CountryCount",
          field: "CountryCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "HotelCount",
          field: "HotelCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 140,
        },
        {
          headerName: "MatchedHotelCount",
          field: "MatchedHotelCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 180,
        },
        {
          headerName: "CurrentOutputCount",
          field: "CurrentOutputCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 180,
        },
        {
          headerName: "MainOperatorName",
          field: "MainOperatorName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          cellClick: true,
          minWidth: 180,
        },
        {
          headerName: "",
          type: "action",
          width: 191,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-success",
              text: "Update Exchange",
              emit: "updateExchange",
            },
            {
              classes: "btn btn-xs waves-effect waves-light btn-success",
              text: "Create Cookie",
              emit: "create",
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
          cellRenderer: this.$BtnCellRenderer,
          cellRendererParams: {
            clicked: function(field) {
              this.$emit(field.emit, field.data);
            },
          },
        },
      ],
      detailShow: null,
      createOpen: null,
      updateExchangeShow: null,
    };
  },
  created() {
    this.$appAxiosAdmin.get(`Countries`).then((response) => {
      this.countries = response.data;
    });
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      this.$appAxiosAdmin
        .get(`Operators/Country/` + this.countryId)
        .then((response) => {
          this.data = response.data;
        });
    },
  },
};
</script>
